import type React from "react";
import { useProgress } from "@/hooks/useProgress";
import { formatDate } from "@/utils/date";

const RecentProgress: React.FC = () => {
	const { progress, loading, error } = useProgress();

	if (loading) return <p>読み込み中...</p>;
	if (error) return <p>エラーが発生しました: {error.message}</p>;

	return (
		<ul className="space-y-2">
			{progress.slice(0, 5).map((item) => (
				<li key={item.id} className="text-sm">
					<div className="flex justify-between items-center">
						<div>
							<span className="font-semibold">進捗: {item.progress}%</span>
							{item.note && (
								<span className="ml-2 text-gray-600">{item.note}</span>
							)}
						</div>
						<span className="text-xs text-gray-500">
							{formatDate(item.createdAt)}
						</span>
					</div>
				</li>
			))}
		</ul>
	);
};

export default RecentProgress;
